<template>
  <div v-if="visible" class="toast" :class="type">
    {{ message }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      message: "",
      type: "info", // default type
    };
  },
  methods: {
    show(message, type = "info", time = 3) {
      this.message = message;
      this.type = type;
      this.visible = true;

      setTimeout(() => {
        this.visible = false;
      }, time * 1000); // 3 seconds
    },
  },
};
</script>

<style scoped>
.toast {
  position: fixed;
  top: 5%;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px 20px;
  background-color: #333;
  color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  transition: opacity 0.3s;
}

.error {
  background-color: #ff0000;
}
.toast.info {
  background-color: #2196f3;
}
</style>
